import {Pagination as ArkPagination} from '@ark-ui/react/pagination';
import {Skeleton} from '@chakra-ui/react';
import {ChakraDiv} from '@linx-security/ui/utils/chakra-elements';

import {withStylesProvider} from '../..';

import {Ellipsis} from './Ellipsis';
import {PaginationItem} from './Item';
import {PaginationNextTrigger, PaginationPrevTrigger} from './Trigger';
import {StylesProvider, useStyles} from './context';
import {paginationTheme} from './theme/theme';

type Props = {
  count: number;
  pageSize: number;
  page: number;
  onChange: (page: number) => void;
  siblingCount?: number;
  isLoading?: boolean;
};

export const SKELETON_HEIGHT = `var(--pagination-skeleton-height)`;
const Pagination = (props: Props) => {
  const {root} = useStyles();
  const {count, page, pageSize, onChange, siblingCount = 1, isLoading = false} = props;

  return (
    <ArkPagination.Root
      count={count}
      pageSize={pageSize}
      siblingCount={siblingCount}
      page={page}
      onPageChange={details => {
        onChange(details.page);
      }}
      asChild>
      <ChakraDiv __css={root}>
        <ArkPagination.Context>
          {pagination => {
            return (
              <>
                <PaginationPrevTrigger disabled={!!pagination.previousPage} isLoaded={!isLoading} />
                {pagination.pages.map((page, index) =>
                  page.type === `page` ? (
                    <Skeleton isLoaded={!isLoading} height={SKELETON_HEIGHT} key={index}>
                      <PaginationItem key={index} {...page}>
                        {page.value}
                      </PaginationItem>
                    </Skeleton>
                  ) : (
                    <Skeleton isLoaded={!isLoading} height={SKELETON_HEIGHT} key={index}>
                      <Ellipsis key={index} index={index}>
                        &#8230;
                      </Ellipsis>
                    </Skeleton>
                  ),
                )}
                <PaginationNextTrigger disabled={!!pagination.nextPage} isLoaded={!isLoading} />
              </>
            );
          }}
        </ArkPagination.Context>
      </ChakraDiv>
    </ArkPagination.Root>
  );
};

export default withStylesProvider(Pagination, StylesProvider, paginationTheme);
export type {Props as PaginationProps};
